import 'backbone.marionette';
import Backbone from 'backbone';

export default Backbone.Wreqr.Channel;
